import type { Client2TrackedTranslation } from '@ps/web-core-intl';
import type { ActiveGameData } from '@ps/web-poker-types';
import { ActiveGameButtonType } from '@ps/web-poker-types';

import { PowerPathType } from '../types';

import {
  TXTCLI_Play_Now,
  TXTCLI_Register__toTournament,
  TXTCLI_Take_Your_Seat,
  TXTCLI_Unregister
} from './buttonUtils.messages.json';

export enum ButtonActionType {
  REGISTER = 'register',
  UNREGISTER = 'unregister',
  TAKE_SEAT = 'takeSeat'
}

export const getButtonActionType = (
  activeGame: ActiveGameData | undefined,
  gameType: PowerPathType | undefined,
  started: boolean = false
): ButtonActionType => {
  let actionType: ButtonActionType;

  switch (gameType) {
    case PowerPathType.SCHEDULED:
      if (activeGame && (started || activeGame.buttonType === ActiveGameButtonType.TAKE_SEAT)) {
        actionType = ButtonActionType.TAKE_SEAT;
      } else if (activeGame && activeGame.buttonType === ActiveGameButtonType.UNREGISTER) {
        actionType = ButtonActionType.UNREGISTER;
      } else {
        actionType = ButtonActionType.REGISTER;
      }
      break;
    case PowerPathType.SIT_AND_GO:
      actionType = activeGame ? ButtonActionType.UNREGISTER : ButtonActionType.REGISTER;
      break;
    default:
      actionType = activeGame ? ButtonActionType.TAKE_SEAT : ButtonActionType.REGISTER;
      break;
  }

  return actionType;
};

export const getButtonTranslation = (
  activeGame: ActiveGameData | undefined,
  gameType: PowerPathType | undefined,
  started: boolean = false
): Client2TrackedTranslation => {
  if (!activeGame) {
    return gameType === PowerPathType.SCHEDULED ? TXTCLI_Register__toTournament : TXTCLI_Play_Now;
  }

  const buttonActionType = getButtonActionType(activeGame, gameType, started);

  let translation: Client2TrackedTranslation;

  switch (buttonActionType) {
    case ButtonActionType.REGISTER:
      translation = TXTCLI_Register__toTournament;
      break;
    case ButtonActionType.UNREGISTER:
      translation = TXTCLI_Unregister;
      break;
    case ButtonActionType.TAKE_SEAT:
      translation = TXTCLI_Take_Your_Seat;
      break;
    default:
      translation = activeGame ? TXTCLI_Take_Your_Seat : TXTCLI_Play_Now;
      break;
  }

  return translation;
};
